import React from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DONATION_TAB = [
  { label: "Details" },
  { label: "Articles" },
  { label: "collections" },
];

const DonationTab = ({ tabValue, setParticularTabValue, t }) => {
  const handleChange = (event, newValue) => {
    setParticularTabValue(newValue);
  };
  return (
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        {DONATION_TAB.map((item, i) => (
          <Tab label={t(`${item.label}`)} {...a11yProps(i)} key={item.label} />
        ))}
      </Tabs>
  );
};

export default DonationTab;
